import React, { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { BRANDS } from "@/data/brands";
import { useT } from "@/i18n/LanguageContext";

// Desktop "Brands" mega dropdown. Cached the filtered brand list with
// useMemo so we don't re-run the filter on every render (only 7 brands,
// but keeps the hook-happy linter happy without cost).
export default function BrandsDropdown({ onSelectBrand, onBrandsSection }) {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const visibleBrands = useMemo(
    () => BRANDS.filter((b) => !b.hideFromNav),
    []
  );

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        data-testid={NAV.linkBrands}
        onClick={onBrandsSection}
        className="inline-flex items-center gap-1 px-4 py-2 text-sm font-medium text-neutral-800 hover:text-[#25bfcf] transition-colors"
        aria-haspopup="true"
        aria-expanded={open}
      >
        {t("nav.brands")}
        <ChevronDown
          className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="absolute left-0 top-full w-[260px] rounded-2xl bg-white shadow-2xl border border-black/5 overflow-hidden"
          >
            <ul className="py-2">
              {visibleBrands.map((b) => (
                <li key={b.slug}>
                  <button
                    data-testid={`nav-brand-${b.slug}`}
                    onClick={() => onSelectBrand(b.slug)}
                    aria-label={b.name}
                    className={`w-full flex items-center justify-center px-2 hover:bg-neutral-50 transition-colors h-24 ${
                      b.slug === "white-elephant" ? "pt-4" : ""
                    }`}
                  >
                    <img
                      src={b.logo}
                      alt={b.name}
                      className={`${b.logoClass || "h-14 max-w-[220px]"} w-auto object-contain`}
                    />
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
